import { render } from "./Scroll.vue?vue&type=template&id=481b1ead&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"

import "./Scroll.vue?vue&type=style&index=0&id=481b1ead&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481b1ead"]])

export default __exports__